module.exports = __webpack_public_path__ + "img/Pic_WGM_LB_a.f5fecd37.gif";